import { Injectable } from '@angular/core';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { IdentityService } from '../authentication/identity.service';
import { SessionService } from '../session/session.service';
import { ErrorsEnum } from '../enum/errors.enum';
import { TextDataResponseDTO } from '../authentication/connection/interfaces/apiInterfaces';
import { StorageKeyEnum } from '../storage/storageKeyEnum.enum';
import { Observable, catchError, map, mergeMap, of, throwError } from 'rxjs';
import { GetPagesCommand, IPagesParameters, IPagesResponse } from './command/getpages.command';
import { GetCountriesCurrentCommand, IGetCurrentCountriesCommandParameters } from '../admin/command/get-current-countries-list.command';
import { GetProvincesListCommand, IGetProvincesCommandParameters } from '../admin/command/get-provinces-list.command';
import { GetCountriesAvaliableCommand, IGetCountriesCommandParameters } from '../admin/command/get-countries-list.command';
import { LabelAddClient } from '../../pages/carrier/client/add-client/labelAddClient';


@Injectable()
export class MultiRegionService {
  constructor(
    private _connectionService: ConnectionServices,
    private _identityService: IdentityService,
    private _sessionService: SessionService,
    // private _notificationsService: NotificationsService
  ) {}

  public getError(errorKey: ErrorsEnum): any {
    let array: Array<TextDataResponseDTO> = new Array<TextDataResponseDTO>();
    array = JSON.parse(
      this._sessionService.getItem(StorageKeyEnum.multiregion)
    );
    if (array != null || array !== undefined) {
      return array.find(f => f.key === errorKey.toString()).value;
    }
  }

  public getLabel(labelKey: string) {
    let array: Array<TextDataResponseDTO> = new Array<TextDataResponseDTO>();
    array = JSON.parse(
      this._sessionService.getItem(StorageKeyEnum.multiregion)
    );
    let value = {} as TextDataResponseDTO;
    if (array != null || array !== undefined) {
      value = array.find(f => f.key === labelKey);
    }
    if (value === undefined || value === null) {
      return labelKey;
    } else {
      return value.value;
    }
  }

  public getControlData(labelKey: string): TextDataResponseDTO {
    let array: TextDataResponseDTO[] = JSON.parse(
      this._sessionService.getItem(StorageKeyEnum.multiregion)
    );
    let value = {} as TextDataResponseDTO;
    if (array != null || array !== undefined) {
      value = (<TextDataResponseDTO[]>array).find(f => f.key === labelKey);
    }
    if (value === undefined || value === null) {
      return {} as TextDataResponseDTO;
    } else {
      return value;
    }
  }

  public getCountry(): string {
    return this._identityService.country;
  }

  public getPages(country: string): Observable<any> {
    let pagesCommand = new GetPagesCommand();
    pagesCommand.setParameters(<IPagesParameters>{
      country: country
    });
    return this._connectionService.Request(pagesCommand).pipe(
        mergeMap((response: any) => {
          this.saveData(response);
          return response.pages; // Create a new observable with pages
        })
      );
  }

  public saveData(pages: IPagesResponse) {
    let data = [];
    for (let page of pages.pages) {
      for (let d of page.data) {
        data.push(d);
      }
    }
    this._sessionService.setItem(
      StorageKeyEnum.multiregion,
      JSON.stringify(data)
    );
  }

  /**MIGRACION! */
  public getOperativeCountries(
    terms?: string
  ): Observable<Array<any>> {
    const countriesCurrentCommand = new GetCountriesCurrentCommand();
    countriesCurrentCommand.setParameters(<IGetCurrentCountriesCommandParameters>{
      terms: terms
    });

    return this._connectionService
    .Request(countriesCurrentCommand)
    .pipe(
      map((response) => {
        return response as Array<any>;
      }),
      catchError((error) => {
        // Muestra el error o lanza un error manejado
        // this._notificationsService.showHttpErrorMessage('Validar ubicación', error);
        return throwError(() => new Error('Error al obtener países operativos'));
      })
    );
  }

  public getCountries(
      terms: string
    ): Observable<Array<any>> {
      const countriesCommand = new GetCountriesAvaliableCommand();
      countriesCommand.setParameters(<IGetCountriesCommandParameters>{
        terms: terms
      });
      return this._connectionService
        .Request(countriesCommand)
        .pipe(
          map(response => {
            return response as any;
          }),
          catchError(error => {
            //this._notificationsService.showHttpErrorMessage('toast.multiregions.title.validate_location', error);
            return throwError(false);
          })
        )
  }

  public getProvinces(
    countryId: string,
    terms: string
  ): Observable<Array<any>> {
    const provincesCommand = new GetProvincesListCommand();
    provincesCommand.setParameters(<IGetProvincesCommandParameters>{
      terms: terms,
      countryId: countryId
    });
    return this._connectionService
        .Request(provincesCommand)
        .pipe(
            map(response => response as Array<any>),
            catchError(error => {
                // this._notificationsService.showHttpErrorMessage('Validar ubicación', error);
                return throwError(() => new Error('Error al obtener provincias'));
            })
        );
  }

//   public getRegions(
//     provinceId: string,
//     terms: string
//   ): Observable<Array<any>> {
//     const regionsCommand = new GetRegionsListCommand();
//     regionsCommand.setParameters(<IGetRegionsCommandParameters>{
//       terms: terms,
//       provinceId: provinceId
//     });
//     return this._connectionService
//       .Request(regionsCommand)
//       .map(response => {
//         return response;
//       })
//       .catch(error => {
//         this._notificationsService.showHttpErrorMessage('Validar ubicación', error);
//         return Observable.throw(false);
//       });
//   }

//   public getCurrentCurrencies(): Observable<Array<any>> {
//     const currencyValuesCommand = new GetCurrencyValuesCommand();
//     return this._connectionService
//       .Request(currencyValuesCommand)
//       .map(response => {
//         return response;
//       })
//       .catch(error => {
//         this._notificationsService.showHttpErrorMessage('Cotizacion dolar', error);
//         return Observable.throw(false);
//       });
//   }

//   public getCurrencyHistory(dateFrom: string , dateTo: string): Observable<Array<any>> {
//     const currencyValuesCommand = new GetCurrencyHistoryCommand();
//     currencyValuesCommand.setParameters(<IGetCurrencyHistoryCommandParameters>{
//       dateFrom: dateFrom,
//       dateTo: dateTo
//     });
//     return this._connectionService
//       .Request(currencyValuesCommand)
//       .map(response => {
//         return response;
//       })
//       .catch(error => {
//         this._notificationsService.showHttpErrorMessage('Cotizacion dolar', error);
//         return Observable.throw(false);
//       });
//   }

//   public setCurrentCurrencies(currencyValues: CurrencyDTO[]): Observable<boolean> {
//     let setCurrenciesCommand = new SetCurrencyValuesCommand();
//     setCurrenciesCommand.setParameters(currencyValues)
//     return this._connectionService
//       .Request(setCurrenciesCommand)
//       .map(data => {
//         this._notificationsService.showSuccessMessage(
//           'Cotizaciones',
//           this.getLabel(SuccessfulMessageEnum.ADD)
//         );
//         return true;
//       })
//       .catch(error => {
//         this._notificationsService.showInternalErrorMessage(
//           'Cotizaciones',
//           error.message
//         );
//         return Observable.throw(error);
//       });
//   }

//   public updateCurrentCurrencies(currencyValues: CurrencyDTO[]): Observable<boolean> {
//     let setCurrenciesCommand = new UpdateCurrencyValuesCommand();
//     setCurrenciesCommand.setParameters(currencyValues)
//     return this._connectionService
//       .Request(setCurrenciesCommand)
//       .map(data => {
//         this._notificationsService.showSuccessMessage(
//           'Cotizaciones',
//           this.getLabel(SuccessfulMessageEnum.MODIFY)
//         );
//         return true;
//       })
//       .catch(error => {
//         this._notificationsService.showInternalErrorMessage(
//           'Cotizaciones',
//           error.message
//         );
//         return Observable.throw(error);
//       });
//   }

//   public getCurrentCurrenciesFromDate(date: string): Observable<Array<any>> {
//     const currencyValuesCommand = new GetCurrencyValuesFromDateCommand();
//     currencyValuesCommand.setParameters(<IGetCurrencyValuesFromDateParameters>{
//       date: date
//     });
//     return this._connectionService
//       .Request(currencyValuesCommand)
//       .map(response => {
//         return response;
//       })
//       .catch(error => {
//         this._notificationsService.showHttpErrorMessage('Cotizacion dolar', error);
//         return Observable.throw(false);
//       });
//   }

  public getLabelAddClient(): Observable<LabelAddClient> {
    // Return observable with LabelAddClient data
    return of(new LabelAddClient());
  }

}
